const terms = {
  title: () => 'Shop italist | Read our terms and conditions',
  description: () =>
    'Please read our Terms and Conditions carefully since we are offering direct-to-consumer imports of worldwide fashion luxury products exclusively from Italy',
};

export default terms;
